import CardFeature from '~/components/Molecules/CardFeature/CardFeature.vue'

export default {
  components: {
    hotCarousel: () => import('~/components/Molecules/Carousel/Carousel.vue'),
  },

  props: {
    title: {
      type: Object,
    },

    body: {
      type: String,
    },

    image: {
      type: Object,
    },

    carousel: {
      type: Array,
    },

    theme: {
      type: String,
      default: '',
      validator: prop => ['', 'light'].includes(prop),
    },
  },

  data() {
    return {
      cardFeature: CardFeature,
      swiperOptions: {
        slidesPerView: 1.1,
        slidesPerColumn: 1,
        spaceBetween: 16,
        allowTouchMove: true,
        slidesPerColumnFill: 'row',
        breakpoints: {
          480: {
            slidesPerView: 2,
            slidesPerColumn: 1,
          },
          768: {
            slidesPerView: 2,
            slidesPerColumn: 2,
            allowTouchMove: false,
            spaceBetween: 32,
          },
          1024: {
            slidesPerView: 1,
            slidesPerColumn: 2,
            spaceBetween: 32,
            simulateTouch: false,
            grabCursor: true,
            allowTouchMove: false,
          },
        },
      },
    }
  },
}
